import { jsx as _jsx } from "react/jsx-runtime";
function CaretUpRightCaretDownLeftFromCenter({ className, size = 24, }) {
    return (_jsx("svg", { className: className, height: size, width: size, fill: "currentColor", viewBox: "0 0 24 24", children: _jsx("path", { d: "M5 19v-6h2v4h4v2H5zm12-8V7h-4V5h6v6h-2z" }) }));
}
export default CaretUpRightCaretDownLeftFromCenter;
